module.exports = __webpack_public_path__ + "8582f67700263806ab36fc187c368f08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/princeton_university.png
// module id = 2046
// module chunks = 0